import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import type { LucideIcon } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export type WorkPlacementStatusRow = {
  key: string;
  label: string;
  count: number;
  icon: LucideIcon;
  colour: string;
};

export default function WorkPlacementStatusCard({
  title,
  rows,
  total,
}: {
  title: string;
  rows: WorkPlacementStatusRow[];
  total: number;
}) {
  return (
    <Box p="3" bg="bg.subtle" rounded="md" w="full">
      <Text fontSize="sm" fontWeight="semibold" color="fg.emphasis" mb="2">
        {title}
      </Text>

      <VStack spacing={4} align="stretch">
        {rows.map((row) => (
          <HStack key={row.key} justify="space-between">
            <HStack>
              <Icon as={row.icon} color={row.colour} boxSize={iconSize.sm} />
              <Text fontSize="xs" color="fg.subtle">
                {row.label}
              </Text>
            </HStack>
            <Text fontSize="xs" fontWeight="medium" color={row.colour}>
              {row.count}
            </Text>
          </HStack>
        ))}

        <HStack justify="space-between">
          <Text fontSize="xs" fontWeight="semibold" color="fg.emphasis">
            <Trans>Total</Trans>
          </Text>
          <Text fontSize="xs" fontWeight="semibold" color="fg.emphasis">
            {total}
          </Text>
        </HStack>
      </VStack>
    </Box>
  );
}
